import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentpersonalquestionview";

export default function Personality({ slug }) {
  const [answerlist, setAnswerlist] = useState([]);

  function GetAnswer(questionId) {
    const result = answerlist.filter((answ) => {
      return answ.questionId === questionId; // && answ.lessonName === lessonId;
    });

    if (result.length > 0) return result[0].studentAnswer;
    else return "";
  }

  async function GetData() {
    const answers = await getStudentIdData(slug);
    setAnswerlist(answers);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className="settings-widget">
      <div className="settings-inner-blk p-0">
        <div className="checkout-form personal-address add-course-info">
          <div className="personal-info-head">
            <h4>Student Personality Assessment</h4>
          </div>
          <div className="comman-space pb-0">
            {answerlist.map(function (data, ix) {
              return (
                <div
                  className="p-2"
                  key={data.questionId}
                  style={ix % 2 == 0 ? { backgroundColor: "#E0EAF5" } : {}}
                >
                  <div className="instruct-review-blk ">
                    <div className="review-item">
                      <div className="instructor-wrap border-0 m-0">
                        <div className="about-instructor">
                          <div className="instructor-detail">
                            <h5>{data.pname}</h5>
                          </div>
                        </div>
                      </div>
                      <div className="rev-info">{data.studentAnswer}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
